import useApiService from "../../../../hooks/useApiService";
import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as React from "react";
import { EmployeeDetail } from "../../../../models/employee.interface";
import { formDataType } from "../AddSite";

interface EmployeesProps {
  handleChange: (name: string, value: number[]) => void;
  formData: formDataType;
}

export function Employees({ handleChange, formData }: EmployeesProps) {
  const [employees, setEmployees] = useState<EmployeeDetail[]>([]);
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeDetail[]>([]);
  const [rowClick, __] = useState(true);

  const { loading: loadingEmployees } = useApiService<EmployeeDetail[]>({
    url: "employee",
    method: "GET",
    apiName: "core",
    onSuccess: res => {
      const selected = res.filter(employee => formData.employees?.includes(employee.id));
      setSelectedEmployees(selected);
      setEmployees(res);
    },
  });

  function handleSelectionChange(e: any) {
    setSelectedEmployees(e.value as EmployeeDetail[]);
    handleChange(
      "employees",
      e.value.map((item: EmployeeDetail) => item.id)
    );
  }
  return (
    <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column" }}>
      <p className={"mt-4"}>
        Which employees will be working on site? This can be updated and expanded once the site is
        created as well.
      </p>
      <div style={{ flex: 1, overflowY: "auto", padding: "0 1rem 1rem" }}>
        {/*@ts-ignore*/}
        <DataTable
          value={employees ?? []}
          selectionMode={rowClick ? "multiple" : null}
          selection={selectedEmployees}
          onSelectionChange={(e: any) => {
            handleSelectionChange(e);
          }}
          dataKey={"id"}
          tableStyle={{ minWidth: "50rem" }}
          loading={loadingEmployees}
        >
          <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
          <Column header={"Name"} field={"full_name"} style={{ minWidth: "12rem" }} />
          <Column header={"Title"} field={"title"} />
          <Column header={"Appointment"} field={"appointment_list"} />
          <Column header={"Employee number"} field={"employee_number"} />
          <Column header={"Phone"} field={"mobile"} />
          <Column header={"Email"} field={"email"} />
        </DataTable>
      </div>
    </div>
  );
}
